let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("i56fm"), load("19KJH"), load("ffEVr"), load("hjv2W")]).then(() => parcelRequire('8aT3t'));